export const CII_UNSATISFACTORY_WARNING_MESSAGES = {
    REPORT_SUMMARY_UNSATISFACTORY_WARNING:
        "Vessel has obtained an unsatisfactory CII rating, please check\nif a resubmission of the SEEMP Part III is needed.",

    VERIFICATION_UNSATISFACTORY_WARNING:
        "Vessel has obtained an unsatisfactory CII rating, please check\nif a resubmission of the SEEMP Part III has been completed.",
};